// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mreg {
    --mreg-ink: #0f172a;
    --mreg-muted: #64748b;
    --mreg-line: #e2e8f0;
    --mreg-blue: #2563eb;
    --mreg-blue-soft: #eff6ff;
    --mreg-green: #16a34a;
    --mreg-surface: #f8fafc;
    --mreg-panel: #f0f9ff;
}

.mreg-title {
    font-size: 1.85rem;
    font-weight: 700;
    color: var(--mreg-ink);
    margin: 0 0 6px;
    letter-spacing: -0.02em;
}

.mreg-sub {
    color: var(--mreg-muted);
    margin: 0 0 18px;
    font-size: 0.98rem;
}

.mreg-page-head {
    margin-bottom: 4px;
}

.mreg-stepper {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 0;
    padding: 0;
    margin: 0 0 24px;
    max-width: 520px;
}

.mreg-step {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
    position: relative;
    color: var(--mreg-muted);
    font-size: 0.88rem;
    font-weight: 600;
}

.mreg-step:not(:last-child)::after {
    content: '';
    flex: 1 1;
    height: 2px;
    background: var(--mreg-line);
    margin: 0 10px;
    min-width: 24px;
}

.mreg-step.is-done:not(:last-child)::after,
.mreg-step.is-active:not(:last-child)::after {
    background: var(--mreg-blue);
}

.mreg-step-dot {
    width: 28px;
    height: 28px;
    border-radius: 999px;
    border: 2px solid var(--mreg-line);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    background: #fff;
    flex-shrink: 0;
}

.mreg-step.is-done .mreg-step-dot {
    border-color: var(--mreg-green);
    background: var(--mreg-green);
    color: #fff;
}

.mreg-step.is-active {
    color: var(--mreg-ink);
}

.mreg-step.is-active .mreg-step-dot {
    border-color: var(--mreg-blue);
    background: var(--mreg-blue);
    color: #fff;
}

.mreg-step-label {
    white-space: nowrap;
}

.mreg-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
    gap: 20px;
    align-items: start;
}

.mreg-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
}

.mreg-card {
    border: 1px solid var(--mreg-line);
    border-radius: 14px;
    padding: 22px 24px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.mreg-card-freetext {
    padding-top: 18px;
}

.mreg-card-tracks {
    height: 100%;
}

.mreg-card-title {
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--mreg-ink);
}

.mreg-card-sub {
    color: var(--mreg-muted);
    font-size: 0.9rem;
    margin: 0 0 16px;
    line-height: 1.45;
}

.mreg-profile {
    display: flex;
    gap: 14px;
    align-items: center;
    margin-bottom: 18px;
}

.mreg-avatar {
    width: 52px;
    height: 52px;
    border-radius: 999px;
    object-fit: cover;
    border: 2px solid var(--mreg-line);
    flex-shrink: 0;
}

.mreg-avatar-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #dbeafe;
    color: #1d4ed8;
    font-weight: 700;
    font-size: 0.95rem;
}

.mreg-profile-name {
    font-weight: 700;
    color: var(--mreg-ink);
    font-size: 1rem;
    margin-bottom: 2px;
}

.mreg-profile-meta {
    color: var(--mreg-muted);
    font-size: 0.88rem;
    line-height: 1.4;
}

.mreg-field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 16px;
}

.mreg-field-full {
    grid-column: 1 / -1;
}

.mreg-field {
    display: block;
}

.mreg-field-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 6px;
    color: var(--mreg-ink);
}

.mreg-field-label-upper {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--mreg-muted);
    font-weight: 700;
}

.mreg-optional {
    text-transform: none;
    letter-spacing: 0;
    font-weight: 500;
}

.mreg-input-readonly {
    background: var(--mreg-surface) !important;
    color: var(--mreg-ink);
    border-color: var(--mreg-line);
}

.mreg-choice-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 8px;
}

.mreg-choice {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    border: 1px solid var(--mreg-line);
    border-radius: 10px;
    padding: 12px 14px;
    margin: 0;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.mreg-choice-input {
    margin-top: 3px;
    flex-shrink: 0;
    accent-color: var(--mreg-blue);
}

.mreg-choice.is-selected {
    border-color: #93c5fd;
    background: var(--mreg-blue-soft);
}

.mreg-choice.is-disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.mreg-choice-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.mreg-choice-label {
    font-weight: 600;
    color: var(--mreg-ink);
    font-size: 0.92rem;
}

.mreg-choice-desc {
    font-size: 0.88rem;
    color: var(--mreg-muted);
    line-height: 1.35;
}

.mreg-freetext-wrap {
    margin: 0;
}

.mreg-textarea {
    resize: vertical;
    min-height: 96px;
}

.mreg-hint {
    margin: 8px 0 0;
    font-size: 0.82rem;
    color: var(--mreg-muted);
}

.mreg-counter {
    text-align: right;
}

.mreg-tracks-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 2px;
}

.mreg-tracks-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--mreg-blue-soft);
    color: var(--mreg-blue);
    font-size: 0.8rem;
    font-weight: 700;
    white-space: nowrap;
    flex-shrink: 0;
}

.mreg-track-grid {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.mreg-track-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    text-align: left;
    border: 1px solid var(--mreg-line);
    border-radius: 12px;
    padding: 14px 14px 12px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.mreg-track-card:hover:not(:disabled) {
    border-color: #93c5fd;
}

.mreg-track-card.is-selected {
    border-color: var(--mreg-blue);
    background: var(--mreg-blue-soft);
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.15);
}

.mreg-track-card.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.mreg-track-name {
    font-weight: 650;
    color: var(--mreg-ink);
    font-size: 0.9rem;
    line-height: 1.3;
}

.mreg-track-warning {
    margin: 12px 0 0;
    font-size: 0.85rem;
    color: #b45309;
}

.mreg-submit-panel {
    margin-top: 20px;
    margin-bottom: 32px;
    padding: 22px 24px;
    border-radius: 14px;
    background: var(--mreg-panel);
    border: 1px solid #bae6fd;
}

.mreg-submit-title {
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0 0 8px;
    color: var(--mreg-ink);
}

.mreg-submit-copy {
    margin: 0 0 16px;
    color: var(--mreg-muted);
    font-size: 0.92rem;
    line-height: 1.45;
    max-width: 52rem;
}

.mreg-action-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
}

.mreg-btn-draft {
    border: 1px solid #93c5fd;
    background: #fff;
    color: #1d4ed8;
    font-weight: 600;
    padding: 10px 18px;
    border-radius: 10px;
}

.mreg-btn-draft:hover:not(:disabled) {
    background: #eff6ff;
}

.mreg-btn-submit {
    border: none;
    background: var(--mreg-green);
    color: #fff;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 10px;
}

.mreg-btn-submit:hover:not(:disabled) {
    background: #15803d;
}

.mreg-submit-foot {
    margin: 14px 0 0;
    font-size: 0.82rem;
    color: var(--mreg-muted);
}

.mreg-action-msg {
    margin: 0 0 10px;
    font-size: 0.92rem;
}

.mreg-action-msg.is-ok {
    color: #15803d;
}

.mreg-action-msg.is-err {
    color: #dc2626;
}

.mreg-banner {
    border: 1px solid #bbf7d0;
    background: #f0fdf4;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 16px;
    color: #166534;
}

.mreg-banner-note {
    margin: 6px 0 0;
    font-size: 0.9rem;
}

.mreg-state {
    max-width: 40rem;
}

@media (max-width: 960px) {
    .mreg-layout {
        grid-template-columns: 1fr;
    }

    .mreg-step-label {
        display: none;
    }

    .mreg-step:not(:last-child)::after {
        min-width: 12px;
        margin: 0 6px;
    }
}

@media (max-width: 640px) {
    .mreg-field-grid {
        grid-template-columns: 1fr;
    }

    .mreg-track-grid {
        grid-template-columns: 1fr;
    }

    .mreg-title {
        font-size: 1.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentee/menteeRegistration.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;IACP,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,SAAO;IACP,WAAW;IACX,4BAA4B;IAC5B,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kCAAkC;IAClC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uDAAuD;IACvD,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0DAA0D;AAC9D;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;IACjC,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iFAAiF;AACrF;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".mreg {\n    --mreg-ink: #0f172a;\n    --mreg-muted: #64748b;\n    --mreg-line: #e2e8f0;\n    --mreg-blue: #2563eb;\n    --mreg-blue-soft: #eff6ff;\n    --mreg-green: #16a34a;\n    --mreg-surface: #f8fafc;\n    --mreg-panel: #f0f9ff;\n}\n\n.mreg-title {\n    font-size: 1.85rem;\n    font-weight: 700;\n    color: var(--mreg-ink);\n    margin: 0 0 6px;\n    letter-spacing: -0.02em;\n}\n\n.mreg-sub {\n    color: var(--mreg-muted);\n    margin: 0 0 18px;\n    font-size: 0.98rem;\n}\n\n.mreg-page-head {\n    margin-bottom: 4px;\n}\n\n.mreg-stepper {\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 0;\n    padding: 0;\n    margin: 0 0 24px;\n    max-width: 520px;\n}\n\n.mreg-step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    position: relative;\n    color: var(--mreg-muted);\n    font-size: 0.88rem;\n    font-weight: 600;\n}\n\n.mreg-step:not(:last-child)::after {\n    content: '';\n    flex: 1;\n    height: 2px;\n    background: var(--mreg-line);\n    margin: 0 10px;\n    min-width: 24px;\n}\n\n.mreg-step.is-done:not(:last-child)::after,\n.mreg-step.is-active:not(:last-child)::after {\n    background: var(--mreg-blue);\n}\n\n.mreg-step-dot {\n    width: 28px;\n    height: 28px;\n    border-radius: 999px;\n    border: 2px solid var(--mreg-line);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.78rem;\n    font-weight: 700;\n    background: #fff;\n    flex-shrink: 0;\n}\n\n.mreg-step.is-done .mreg-step-dot {\n    border-color: var(--mreg-green);\n    background: var(--mreg-green);\n    color: #fff;\n}\n\n.mreg-step.is-active {\n    color: var(--mreg-ink);\n}\n\n.mreg-step.is-active .mreg-step-dot {\n    border-color: var(--mreg-blue);\n    background: var(--mreg-blue);\n    color: #fff;\n}\n\n.mreg-step-label {\n    white-space: nowrap;\n}\n\n.mreg-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n    gap: 20px;\n    align-items: start;\n}\n\n.mreg-col {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-width: 0;\n}\n\n.mreg-card {\n    border: 1px solid var(--mreg-line);\n    border-radius: 14px;\n    padding: 22px 24px;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.mreg-card-freetext {\n    padding-top: 18px;\n}\n\n.mreg-card-tracks {\n    height: 100%;\n}\n\n.mreg-card-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    margin: 0 0 4px;\n    color: var(--mreg-ink);\n}\n\n.mreg-card-sub {\n    color: var(--mreg-muted);\n    font-size: 0.9rem;\n    margin: 0 0 16px;\n    line-height: 1.45;\n}\n\n.mreg-profile {\n    display: flex;\n    gap: 14px;\n    align-items: center;\n    margin-bottom: 18px;\n}\n\n.mreg-avatar {\n    width: 52px;\n    height: 52px;\n    border-radius: 999px;\n    object-fit: cover;\n    border: 2px solid var(--mreg-line);\n    flex-shrink: 0;\n}\n\n.mreg-avatar-initials {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #dbeafe;\n    color: #1d4ed8;\n    font-weight: 700;\n    font-size: 0.95rem;\n}\n\n.mreg-profile-name {\n    font-weight: 700;\n    color: var(--mreg-ink);\n    font-size: 1rem;\n    margin-bottom: 2px;\n}\n\n.mreg-profile-meta {\n    color: var(--mreg-muted);\n    font-size: 0.88rem;\n    line-height: 1.4;\n}\n\n.mreg-field-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px 16px;\n}\n\n.mreg-field-full {\n    grid-column: 1 / -1;\n}\n\n.mreg-field {\n    display: block;\n}\n\n.mreg-field-label {\n    display: block;\n    font-size: 0.85rem;\n    font-weight: 600;\n    margin-bottom: 6px;\n    color: var(--mreg-ink);\n}\n\n.mreg-field-label-upper {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--mreg-muted);\n    font-weight: 700;\n}\n\n.mreg-optional {\n    text-transform: none;\n    letter-spacing: 0;\n    font-weight: 500;\n}\n\n.mreg-input-readonly {\n    background: var(--mreg-surface) !important;\n    color: var(--mreg-ink);\n    border-color: var(--mreg-line);\n}\n\n.mreg-choice-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: grid;\n    gap: 8px;\n}\n\n.mreg-choice {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    border: 1px solid var(--mreg-line);\n    border-radius: 10px;\n    padding: 12px 14px;\n    margin: 0;\n    cursor: pointer;\n    background: #fff;\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.mreg-choice-input {\n    margin-top: 3px;\n    flex-shrink: 0;\n    accent-color: var(--mreg-blue);\n}\n\n.mreg-choice.is-selected {\n    border-color: #93c5fd;\n    background: var(--mreg-blue-soft);\n}\n\n.mreg-choice.is-disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.mreg-choice-body {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.mreg-choice-label {\n    font-weight: 600;\n    color: var(--mreg-ink);\n    font-size: 0.92rem;\n}\n\n.mreg-choice-desc {\n    font-size: 0.88rem;\n    color: var(--mreg-muted);\n    line-height: 1.35;\n}\n\n.mreg-freetext-wrap {\n    margin: 0;\n}\n\n.mreg-textarea {\n    resize: vertical;\n    min-height: 96px;\n}\n\n.mreg-hint {\n    margin: 8px 0 0;\n    font-size: 0.82rem;\n    color: var(--mreg-muted);\n}\n\n.mreg-counter {\n    text-align: right;\n}\n\n.mreg-tracks-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 2px;\n}\n\n.mreg-tracks-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: var(--mreg-blue-soft);\n    color: var(--mreg-blue);\n    font-size: 0.8rem;\n    font-weight: 700;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.mreg-track-grid {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.mreg-track-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n    text-align: left;\n    border: 1px solid var(--mreg-line);\n    border-radius: 12px;\n    padding: 14px 14px 12px;\n    background: #fff;\n    cursor: pointer;\n    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.mreg-track-card:hover:not(:disabled) {\n    border-color: #93c5fd;\n}\n\n.mreg-track-card.is-selected {\n    border-color: var(--mreg-blue);\n    background: var(--mreg-blue-soft);\n    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.15);\n}\n\n.mreg-track-card.is-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.mreg-track-name {\n    font-weight: 650;\n    color: var(--mreg-ink);\n    font-size: 0.9rem;\n    line-height: 1.3;\n}\n\n.mreg-track-warning {\n    margin: 12px 0 0;\n    font-size: 0.85rem;\n    color: #b45309;\n}\n\n.mreg-submit-panel {\n    margin-top: 20px;\n    margin-bottom: 32px;\n    padding: 22px 24px;\n    border-radius: 14px;\n    background: var(--mreg-panel);\n    border: 1px solid #bae6fd;\n}\n\n.mreg-submit-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    margin: 0 0 8px;\n    color: var(--mreg-ink);\n}\n\n.mreg-submit-copy {\n    margin: 0 0 16px;\n    color: var(--mreg-muted);\n    font-size: 0.92rem;\n    line-height: 1.45;\n    max-width: 52rem;\n}\n\n.mreg-action-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n}\n\n.mreg-btn-draft {\n    border: 1px solid #93c5fd;\n    background: #fff;\n    color: #1d4ed8;\n    font-weight: 600;\n    padding: 10px 18px;\n    border-radius: 10px;\n}\n\n.mreg-btn-draft:hover:not(:disabled) {\n    background: #eff6ff;\n}\n\n.mreg-btn-submit {\n    border: none;\n    background: var(--mreg-green);\n    color: #fff;\n    font-weight: 600;\n    padding: 10px 20px;\n    border-radius: 10px;\n}\n\n.mreg-btn-submit:hover:not(:disabled) {\n    background: #15803d;\n}\n\n.mreg-submit-foot {\n    margin: 14px 0 0;\n    font-size: 0.82rem;\n    color: var(--mreg-muted);\n}\n\n.mreg-action-msg {\n    margin: 0 0 10px;\n    font-size: 0.92rem;\n}\n\n.mreg-action-msg.is-ok {\n    color: #15803d;\n}\n\n.mreg-action-msg.is-err {\n    color: #dc2626;\n}\n\n.mreg-banner {\n    border: 1px solid #bbf7d0;\n    background: #f0fdf4;\n    border-radius: 10px;\n    padding: 14px 16px;\n    margin-bottom: 16px;\n    color: #166534;\n}\n\n.mreg-banner-note {\n    margin: 6px 0 0;\n    font-size: 0.9rem;\n}\n\n.mreg-state {\n    max-width: 40rem;\n}\n\n@media (max-width: 960px) {\n    .mreg-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .mreg-step-label {\n        display: none;\n    }\n\n    .mreg-step:not(:last-child)::after {\n        min-width: 12px;\n        margin: 0 6px;\n    }\n}\n\n@media (max-width: 640px) {\n    .mreg-field-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .mreg-track-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .mreg-title {\n        font-size: 1.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
